import { SingleRecordList } from '../../components/common/SingleRecordList';

export const VacancyPageDataList = () => {
  return (
    <SingleRecordList
      resource="vacancy-page-data"
      title="Контент страницы вакансий"
      emptyMessage="Контент страницы вакансий не настроен. Создайте новую запись."
      createButtonLabel="Создать контент"
      editButtonLabel="Редактировать"
    />
  );
};
